import Dispatcher from '../../../flux/dispatcher/dispatcher'
import Constants from '../constant/AuthoriseAccountConstant'
var EventEmitter = require('events').EventEmitter;
var RESPONSE_CHANGE_EVENT = 'globalResponse';
// var Constants = require('components/AuthorisePage/constant/AuthoriseAccountConstant');
var assign = require('object-assign');

var response = {};

function parseResponse(resp){
  response = resp;
}

var GetPortfolioDetailStore = assign({},EventEmitter.prototype,{
   emitChangeEvent: function(event) {
       this.emit(event);
   },
   bind: function(callback) {
       this.on(RESPONSE_CHANGE_EVENT, callback);
   },
   unbind: function(callback) {
       this.removeListener(RESPONSE_CHANGE_EVENT, callback);
   },
   getResponse:function(){
        return response;
   }
});

Dispatcher.register(function(action){

   switch (action.actionType) {
       case Constants.GET_PORTFOLIO_DETAILS:
           var resp = action.data;
           // console.log("profile details store response", resp);
           parseResponse(resp)
           GetPortfolioDetailStore.emitChangeEvent(RESPONSE_CHANGE_EVENT)
           break;
           
       default:
   }
});

export default GetPortfolioDetailStore;